
import Vue from 'vue';
import Vuex from 'vuex';

import uniqid from 'uniqid';

import axios from 'axios';
import moment from 'moment';

// import { Item, ItemAdapter } from './Item';
import { Item } from './Item';
import * as api from '@/libs/api.js';

export function createItem(english, thai) {
  return new Item({
    id: uniqid(),
    sortIndex: new Date().getTime(),
    disabled: false,
    studying: false,
    placeholder: false,
    english,
    thai,
    note: '',
  });
};

function getAuthToken() {

  let token = window.localStorage.getItem('auth-token');
  if (!token) {
    return null;
  }

  // TODO: token expiration should be included with token and checked
  // appropriately here, rather than relying on a separate localstorage item
  // and a magic number for the expiration
  let tokenIssued = window.localStorage.getItem('auth-token-issued');
  let tokenIssuedDiff = moment.utc().diff(tokenIssued, 'hours');
  console.log('token diff:', tokenIssuedDiff, 'utc:', moment.utc().format());
  if (tokenIssuedDiff >= 24) {
    window.localStorage.removeItem('auth-token');
    window.localStorage.removeItem('auth-token-issued');
    return null;
  }

  return token;
}

async function signIn() {
  const username = window.prompt('Username:');
  const password = window.prompt('Password:');
  
  let response;
  try {
    response = await axios.post(`/users/authenticate`, {
      username,
      password,
    });
  } catch (e) {
    window.alert('Failed!');
    return;
  }

  window.localStorage.setItem('auth-token', response.data.token);
  window.localStorage.setItem('auth-token-issued', moment.utc().format());
  window.location.reload();
}

Vue.use(Vuex);

export const store = new Vuex.Store ({
  state: {
    items: {},
    ready: false,
  },

  getters: {
    itemsById: (state) => {
      return state.items;
    },
    newItems: (state) => {
      return Object.values(state.items)
        .filter((item) => !item.studying && !item.placeholder)
        .sort((a, b) => a.sortIndex - b.sortIndex);
    },

    async newItemCandidates(state) {
      // TODO: there must be some good way to refactor this to avoid
      // duplication...
      const newItems = Object.values(state.items)
        .filter((item) => !item.studying && !item.placeholder)
        .sort((a, b) => a.sortIndex - b.sortIndex);

      const candidates = [];

      await Promise.all(newItems.map(async (item) => {
        if (await item.readyToLearn()) {
          candidates.push(item);
        }
      }));

      return candidates;
    },

    reviewItems: (state) => {
      return Object.values(state.items)
        .filter((item) => item.studying && !item.placeholder);
    },
    markedItems: (state) => {
      return Object.values(state.items)
        .filter((item) => item.placeholder);
    },
    itemsReadyForReview(state) {
      return Object.values(state.items)
        .filter((item) => {
          return (
            item.studying
            && !item.placeholder
            && !item.disabled
            && item.itemReadyToReview()
          );
        });
    },
  },

  mutations: {
    init(state, items) {
      const itemsById = {};
      for (let item of items) {
        itemsById[item.id] = item;
      }
      state.items = itemsById;
      state.ready = true;
    },
    addItems(state, newItems) {
      for (let newItem of newItems) {
        Vue.set(state.items, newItem.id, newItem);
      }
    },
    addHistoryItem(state, { item, historyEntry }) {
      const newItem = Object.assign({}, item);
      newItem.history.push(historyEntry);
      Vue.set(state.items[item.id], newItem);
    },
    updateItem(state, item) {
      Vue.set(state.items, item.id, item);
    },
    deleteItem(state, itemId) {
      Vue.delete(state.items, itemId);
    },
  },

  actions: {
    async init({ commit }) {
      const token = getAuthToken();
      if (!token) {
        return signIn();
      }

      axios.defaults.headers.common = {'Authorization': `Bearer ${token}`}

      const items = await api.getAllItems();
      commit('init', items);
    },

    async putItem({ commit }, item) {
      await api.putItem(item);
      commit('updateItem', item);
    },

    async addItems({ commit }, newItems) {
      await Promise.all(newItems.map((item) => {
        return api.postItem(item);
      }));
      commit('addItems', newItems);
    },

    async addHistoryItem({ commit }, { item, historyEntry }) {
      const adaptedHistoryEntry = {
        itemId: item.id,
        score: historyEntry.score,
        entryCreated: new Date(historyEntry.date).toISOString(),
      };
      await axios.post(`/item-history-entries`, adaptedHistoryEntry);
      commit('addHistoryItem', { item, historyEntry });
    },

    async deleteItem({ commit }, itemId) {
      await api.deleteItem(itemId);
      commit('deleteItem', itemId);
    },

    async addMarkedWord({ commit }, thaiWord) {
      let item = createItem("-", thaiWord.text);
      item.placeholder = true;
      await api.putItem(item);
      commit('updateItem', item);
    },

  },
});

store.dispatch('init');